<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app",
  created: async function () {
    const data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
    const settings = JSON.parse(
      localStorage.getItem("calcucil-settings") || "{}"
    );

    const base = process.env.BASE_URL;

    this.muteSound = settings.muteSound || false;
    this.muteMusic = settings.muteMusic || false;

    await this.cargarTools();
    const tools = window.tools;
    console.log("device cargando");
    await tools.addJS(`${base}static/libs/device/device.js`);
    console.log("device cargado");
    const device = window.device;
    await device.ready();

    if (device.get("platform") === "browser") {
      if (false && process.env.NODE_ENV === "production") {
        window.location = "https://games.almacil.com/calcucil";
        return false;
      }
    } else {
      this.processAdMob();
      this.processEvents();
    }

    window.introMusic =
      window.introMusic || new Audio(base + "static/sounds/intro.mp3");

    window.introMusic.loop = true;
    if (!this.muteMusic) {
      window.introMusic.play();
    }
  },
  methods: {
    cargarTools() {
      return new Promise((resolve, _) => {
        const base = process.env.BASE_URL;
        const script = window.document.createElement("script");
        script.src = `${base}static/libs/tools/tools.js`;
        script.type = "text/javascript";
        if (script.readyState) {
          // IE
          script.onreadystatechange = function () {
            if (
              script.readyState === "loaded" ||
              script.readyState === "complete"
            ) {
              script.onreadystatechange = null;
              resolve(true);
            }
          };
        } else {
          // Others
          script.onload = function () {
            resolve(true);
          };
        }
        window.document.getElementsByTagName("head")[0].appendChild(script);
      });
    },

    processAdMob() {
      const device = window.device;
      const platform = device.get("platform");
      const adIds = (window.adIds = {
        ios: {
          banner: "ca-app-pub-5162375150967923/6611812751",
          interstitial: "ca-app-pub-5162375150967923/8077895526",
        },
        android: {
          banner: "ca-app-pub-5162375150967923/1786560164", // "ca-app-pub-3940256099942544/6300978111",
          interstitial: "ca-app-pub-5162375150967923/6402137184", // "ca-app-pub-3940256099942544/1033173712",
          reward: "ca-app-pub-5162375150967923/3968037111"
        },
      });
      // IDFA o ID de publicidad SM10: 46395f84-a08e-4547-ab00-2716b88b7dee
      // ID APP Google Pruebas: ca-app-pub-3940256099942544~3347511713

      device.addListener("admob", (message) => {
        if (!message) {
          return;
        }

        if (message.action === "createBanner") {
          if (message.success) {
            // device.postMessage("admob", { action: "showBanner", options: 8 });
          }
        }

        if (message.action === "isInterstitialReady") {
          if (message.response) {
            // device.postMessage("admob", { action: "showInterstitialAd" });
          }
        }
      });

      device.postMessage("nativeBody", {
        html: `
        <div style="padding:1rem;">
          Calcucil es un juego de cálculo mental en el que tienes que indicar si la operación matemática que aparece en pantalla es correcta o incorrecta.
          
          Sumarás puntos y tiempo con cada acierto y restarás puntos con cada fallo.
          
          Cuando consigues más tiempo y aciertos subirás de nivel y las operaciones matemáticas serán más complejas pero también ganarás más puntos.
        </div>
        `
      });
      device.postMessage("admob", { action: "events" });
      device.postMessage("admob", {
        action: "setOptions",
        options: {
          autoShow: true,
          isTesting: false,
          bgColor: "black",
          overlap: true,
        },
      });
      device.postMessage("admob", {
        action: "createBanner",
        options: {
          adId: adIds[platform].banner,
          autoShow: true,
          isTesting: false,
          overlap: true,
        },
      });
    },

    processEvents() {
      const device = window.device;
      device.addListener("pause", () => {
        if (!this.muteMusic) {
          window.introMusic.pause();
        }
      });
      device.addListener("resume", () => {
        if (!this.muteMusic) {
          window.introMusic.play();
        }
      });
    },
  },
};
</script>

<style>
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue